import { useId } from 'react';
import { useTranslation } from 'react-i18next';

/** 5.1: 6 px track + « 18 / 42 tickets ». A waiting job (total unknown yet) reads « 0 / N » from the caller's fallback. */
const ProgressBar = ({ done, total }: { done: number; total: number }) => {
  const { t } = useTranslation();
  const labelId = useId();
  const safeTotal = Math.max(Number(total) || 0, 0);
  const safeDone = Math.min(Math.max(Number(done) || 0, 0), safeTotal);
  const percent = safeTotal ? (safeDone / safeTotal) * 100 : 0;

  return (
    <div className="flex flex-col gap-1.5">
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeTotal}
        aria-valuenow={safeDone}
        aria-labelledby={labelId}
        className="h-1.5 overflow-hidden rounded-full bg-zinc-100 dark:bg-zinc-800"
      >
        <div className="h-full rounded-full bg-primary transition-[width]" style={{ width: `${percent}%` }} />
      </div>
      <span id={labelId} className="text-[13px] font-medium tabular-nums">
        {t('{{done}} / {{count}} tickets', { done: safeDone, count: safeTotal })}
      </span>
    </div>
  );
};

export default ProgressBar;
